import { defineMessages } from 'react-intl'
import { CONTRACT_GROUPS } from 'utils/contracts'

export default defineMessages({
  'contractType-retailer': {
    id: 'contractType.retailer',
    defaultMessage: 'Retailer',
  },
  'contractType-productSharing': {
    id: 'contractType.productSharing',
    defaultMessage: 'Product sharing',
  },
  'contractType-updateProductSharing': {
    id: 'contractType.updateProductSharing',
    defaultMessage: 'Update shared products',
  },
  'contractType-productAndModelSharing': {
    id: 'contractType.productAndModelSharing',
    defaultMessage: 'Products sharing (with all 3D assets)',
  },
  'contractType-productAnd3DSmaxSharing': {
    id: 'contractType.productAnd3DSmaxSharing',
    defaultMessage: 'Products sharing (with 3D assets)',
  },
  'contractType-hubstairsToCustomer': {
    id: 'contractType.hubstairsToCustomer',
    defaultMessage: 'nfinite to customer',
  },
  'contractType-customerToHubstairs': {
    id: 'contractType.customerToHubstairs',
    defaultMessage: 'Customer to nfinite',
  },
  'contractType-jobber': {
    id: 'contractType.jobber',
    defaultMessage: 'Jobber',
  },
  'contractType-nfinite': {
    id: 'contractType.nfinite',
    defaultMessage: 'nfinite',
  },
  'contractType-stageTemplateSharing': {
    id: 'contractType.stageTemplateSharing',
    defaultMessage: 'Stage Templates Sharing',
  },
  'contractType-stageTemplateAnd3DSmaxSharing': {
    id: 'contractType.stageTemplateAnd3DSmaxSharing',
    defaultMessage: 'Templates sharing (with 3D assets)',
  },
  'contractType-visualSharing': {
    id: 'contractType.visualSharing',
    defaultMessage: 'Visuals sharing',
  },
  'contractType-expectationSharing': {
    id: 'contractType.expectationSharing',
    defaultMessage: 'Expectations sharing',
  },
  'contractType-supplier': {
    id: 'contractType.supplier',
    defaultMessage: 'Supplier',
  },
  [CONTRACT_GROUPS.RETAILER]: {
    id: 'contract.retailer',
    defaultMessage: 'Retailer',
  },
  [CONTRACT_GROUPS.SUPPLIER]: {
    id: 'contract.brand',
    defaultMessage: 'Brand',
  },
  [CONTRACT_GROUPS.JOBBER]: {
    id: 'contract.jobber',
    defaultMessage: 'Jobber',
  },
})
